import React from 'react';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from './CheckoutForm';
import ResourceService from '../../services/resource.service';

export default class CreditCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stripePromise: null,
            stripeVal: false
        };
        this.getStripeKey();
    }

    getStripeKey() {
        ResourceService.getStripeKey().then(data => {
            this.setState({
                stripePromise: loadStripe(data.toString()),
                stripeVal: true
            });
        }).catch(err => {
            console.log(err);
            return null;
        });
    }

    render() {

        return (
            this.state.stripeVal &&
            <section className="accountModule_wrapper cc_section billing_cc_sec">
                <div className="accModule_head_wrap">
                    <div className="settModule_head_lhs">
                        <h2>Credit Card</h2>
                        <p className="head_info">Provide your credit card information for billing purposes. Prepaid cards will not be accepted.</p>
                    </div>
                </div>
                <Elements stripe={ this.state.stripePromise }>
                    <CheckoutForm />
                </Elements>
            </section>
        );
    }
}